const AWS_REGION = import.meta.env.VITE_AWS_REGION;
const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
const COGNITO_APP_DOMAIN = import.meta.env.VITE_COGNITO_APP_DOMAIN;
const COGNITO_REDIRECT_SIGN_IN = import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN;
const COGNITO_REDIRECT_SIGN_OUT = import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT;
const COGNITO_USERPOOL_ID = import.meta.env.VITE_COGNITO_USERPOOL_ID;
const WEB_SOCKET_COMMUNICATION_URL = import.meta.env.VITE_WEB_SOCKET_COMMUNICATION_URL;
const WEB_SOCKET_TRAFFIC_LIGHT_URL = import.meta.env.VITE_WEB_SOCKET_TRAFFIC_LIGHT_URL;
const SNOW_URL = import.meta.env.VITE_SNOW_URL;
const CCP_URL = import.meta.env.VITE_CCP_URL;
const CONNECT_CONTACT_TRACE_URL = import.meta.env.VITE_CONNECT_CONTACT_TRACE_URL;
const CCP_LOGIN = import.meta.env.VITE_CCP_LOGIN;
const CCP_API_GATEWAY = import.meta.env.VITE_CCP_API_GATEWAY;
const CCP_AUDIO_CHAT_API_GATEWAY = import.meta.env.VITE_CCP_AUDIO_CHAT_API_GATEWAY;
const CONTACT_HISTORY_API_GATEWAY = import.meta.env.VITE_CONTACT_HISTORY_API_GATEWAY;
const KPI_API_GATEWAY = import.meta.env.VITE_KPI_API_GATEWAY;
const CALLER_COUNT_API_GATEWAY = import.meta.env.VITE_CALLER_COUNT_API_GATEWAY;
const DYNAMIC_BUTTONS_API_GATEWAY = import.meta.env.VITE_DYNAMIC_BUTTONS_API_GATEWAY;
const STOP_TASK_API_GATEWAY = import.meta.env.VITE_STOP_TASK_API_GATEWAY;
const EMAIL_INFO_API_GATEWAY = import.meta.env.VITE_EMAIL_INFO_API_GATEWAY;
const SEND_EMAIL_API_GATEWAY = import.meta.env.VITE_SEND_EMAIL_API_GATEWAY;
const AI_WIDGET_URL = import.meta.env.VITE_AI_WIDGET_URL;
const CONTACTS_API_GATEWAY = import.meta.env.VITE_CONTACT_COUNTER_API_GATEWAY;
const VIDEO_DOWNLOAD_URL = import.meta.env.VITE_VIDEO_DOWNLOAD_URL;
const EMAIL_THREAD_URL = import.meta.env.VITE_EMAIL_THREAD_URL;
const SUPPORT_API_GATEWAY = import.meta.env.VITE_SUPPORT_API_GATEWAY;
const STEP_BY_STEP_BASE_URL = import.meta.env.VITE_STEP_BY_STEP_BASE_URL;


export {
  AWS_REGION,
  COGNITO_CLIENT_ID,
  COGNITO_APP_DOMAIN,
  COGNITO_REDIRECT_SIGN_IN,
  COGNITO_REDIRECT_SIGN_OUT,
  COGNITO_USERPOOL_ID,
  WEB_SOCKET_COMMUNICATION_URL,
  WEB_SOCKET_TRAFFIC_LIGHT_URL,
  SNOW_URL,
  CCP_URL,
  CONNECT_CONTACT_TRACE_URL,
  CCP_LOGIN,
  CCP_API_GATEWAY,
  CCP_AUDIO_CHAT_API_GATEWAY,
  CONTACT_HISTORY_API_GATEWAY,
  KPI_API_GATEWAY,
  CALLER_COUNT_API_GATEWAY,
  DYNAMIC_BUTTONS_API_GATEWAY,
  STOP_TASK_API_GATEWAY,
  EMAIL_INFO_API_GATEWAY,
  SEND_EMAIL_API_GATEWAY,
  AI_WIDGET_URL,
  CONTACTS_API_GATEWAY,
  VIDEO_DOWNLOAD_URL,
  EMAIL_THREAD_URL,
  SUPPORT_API_GATEWAY,
  STEP_BY_STEP_BASE_URL
};
